import { gql } from "@apollo/client";
import { userDetails } from "../../../../../../utils/commonQueryTypes";

export const AddItem = gql`
  mutation AddItem(
    $token: String!
    $input: CreateAtsStckItemInput!
    $customer_id: ID!
    $user_details: SubscribedUser!
  ) {
    AddItem(
      token: $token
      input: $input
      customer_id: $customer_id
      user_details: $user_details
    )
  }
`;

export const UpdateItem = gql`
  mutation UpdateItem(
    $token: String!
    $item_id: ID!
    $input: UpdateAtsStckItemInput!
    $user_details: SubscribedUser!
  ) {
    UpdateItem(
      token: $token
      input: $input
      item_id: $item_id
      user_details: $user_details
    )
  }
`;

export const DeleteItem = gql`
  mutation DeleteItem(
    $token: String!
    $item_id: ID!
    $user_details: SubscribedUser!
  ) {
    DeleteItem(token: $token, item_id: $item_id, user_details: $user_details)
  }
`;
export const ImportItemsDetails = gql`
  mutation ImportItems(
    $token: String!
    $customerID: ID!
    $user_details: SubscribedUser!
    $input: ImportItems!
  ) {
    ImportItems(
      token: $token
      customerID: $customerID
      user_details: $user_details
      input: $input
    )
  }
`;
export const ItemDetailsImport = gql`
  mutation ImportItemDetails(
    $token: String!
    $customerID: ID!
    $companyID: ID!
    $user_details: SubscribedUser!
    $input: ItemDetails!
    $todaysDate: Time!
  ) {
    ImportItemDetails(
      token: $token
      customerID: $customerID
      companyID: $companyID
      user_details: $user_details
      input: $input
      todaysDate: $todaysDate
    )
  }
`;
export const ExportItemsTemplate = gql`
  query ExportItemsTemplate(
    $token: String!
    $customerID: ID!
    $parameters: [String!]!
  ) {
    ExportItemsTemplate(
      token: $token
      customerID: $customerID
      parameters: $parameters
    )
  }
`;
export const ExportSubsidiaryTemplate = gql`
  query ExportSubsidiaryTemplate($token: String!, $customerID: ID!) {
    ExportSubsidiaryTemplate(token: $token, customerID: $customerID)
  }
`;
export const ExportItemDetailsTemplate = gql`
  query ExportItemDetailsTemplate(
    $token: String!
    $customerID: ID!
    $itemsList: [String!]!
  ) {
    ExportItemDetailsTemplate(
      token: $token
      customerID: $customerID
      itemsList: $itemsList
    )
  }
`;
export const ValidateItemsForImport = gql`
  query ValidateItemsForImport(
    $token: String!
    $customerID: ID!
    $desc: String!
  ) {
    ValidateItemsForImport(token: $token, customerID: $customerID, desc: $desc)
  }
`;
export const ValidateItemsDetailsForImport = gql`
  query ValidateItemsDetailsForImport(
    $token: String!
    $customerID: ID!
    $companyID: ID!
    $input: ValidateItemDetails!
  ) {
    ValidateItemsDetailsForImport(
      token: $token
      customerID: $customerID
      companyID: $companyID
      input: $input
    )
  }
`;

export const AddTicketDetails = gql`
  mutation AddTicketDetails(
    $token: String!
    $todaysDate: Time!
    $customerID: ID!
    $ticketID: ID!
    $input: TicketDetailsInput!
    $assetDetails: [TicketAssetsInput]!
    $deviceTypes: [DeviceTypes]!
    $user_details: SubscribedUser!
  ) {
    AddTicketDetails(
      token: $token
      todaysDate: $todaysDate
      customerID: $customerID
      ticketID: $ticketID
      input: $input
      assetDetails: $assetDetails
      deviceTypes: $deviceTypes
      user_details: $user_details
    ) {
      id
    }
  }
`;

export const AddBlowCount = gql`
  mutation AddBlowCount(
    $token: String!
    $customerID: ID!
    $todaysDate: Time!
    $input: [CalibrationData!]!
    $user_details: SubscribedUser!
  ) {
    AddBlowCount(
      token: $token
      customerID: $customerID
      todaysDate: $todaysDate
      input: $input
      user_details: $user_details
    )
  }
`;

export const UpdateBlowCount = gql`
  mutation UpdateBlowCount(
    $token: String!
    $customerID: ID!
    $input: [UpdateCalibrationData!]!
    $user_details: SubscribedUser!
  ) {
    UpdateBlowCount(
      token: $token
      customerID: $customerID
      input: $input
      user_details: $user_details
    )
  }
`;

export const AddCalibrate = gql`
  mutation AddCalibrate(
    $token: String!
    $customerID: ID!
    $itemDetailsID: ID!
    $todaysDate: Time!
    $user_details: SubscribedUser!
  ) {
    AddCalibrate(
      token: $token
      customerID: $customerID
      todaysDate: $todaysDate
      itemDetailsID: $itemDetailsID
      user_details: $user_details
    )
  }
`;

export const DeleteCalibrate = gql`
  mutation DeleteCalibrate(
    $token: String!
    $customerID: ID!
    $calibrationID: ID!
    $user_details: SubscribedUser!
  ) {
    DeleteCalibrate(
      token: $token
      customerID: $customerID
      calibrationID: $calibrationID
      user_details: $user_details
    )
  }
`;

export const DeleteItemDetails = gql`
  mutation DeleteItemDetails(
    $token: String!
    $customerID: ID!
    $itemDetailsID: ID!
    $user_details: SubscribedUser!
  ) {
    DeleteItemDetails(
      token: $token
      customerID: $customerID
      itemDetailsID: $itemDetailsID
      user_details: $user_details
    )
  }
`;

export const MoveItemDetails = gql`
  mutation MoveItemDetails(
    $token: String!
    $customerID: ID!
    $user_details: SubscribedUser!
    $input: [MoveItemDetailsInput]
  ) {
    MoveItemDetails(
      token: $token
      customerID: $customerID
      user_details: $user_details
      input: $input
    )
  }
`;
